import { useTranslation } from 'react-i18next';
import { ILicenseUsage } from '../../~store/models/LicenseUsage';
import './LicenseDetails.css';
import { EXTREME_LOW_USAGE_LEFT, LOW_USAGE_LEFT, MS_IN_DAY } from './constants';
import { getXmlTagValue } from 'src/app/shared/helpers/xml-helper/XmlHelper';
import { getDateTime } from "../../../shared/helpers/date-helper/DateFormats";

interface ILicenseDetailsProps {
  licenseUsage: ILicenseUsage;
  licenseXml: string;
}

export default function LicenseDetails(props: ILicenseDetailsProps) {
  const { licenseUsage, licenseXml } = props;
  const { t } = useTranslation();

  const expires = licenseUsage && Date.parse(getXmlTagValue(licenseXml, 'Expiration') ?? '');
  const daysLeft = expires && Math.floor((expires - Date.now()) / MS_IN_DAY);
  
  function getLowLeftClass(max: number, left: number)
  {
    var perc = left / max;
    return perc > LOW_USAGE_LEFT ? '' : perc > EXTREME_LOW_USAGE_LEFT ? 'low-usage-left-row' : 'extreme-low-usage-left-row';
  }
  
  return (
    <div className='license-details'>
      <div className='expiration-data'>
        <p className='expiration-date'>{t('license.licenseExpiresAt', { interpolation: {escapeValue: false}, date: getDateTime(new Date(expires)) })}</p>
        <p className='days-left'>({t('license.licenseDaysLeft', { interpolation: {escapeValue: false}, days: daysLeft})})</p>
      </div>
      <table className='license-details-table'>
        <thead className='license-details-header'>
          <tr className='license-details-row'>
            <th className='license-details-cell'></th>
            <th className='license-details-cell'>{t('license.currentUsage')}</th>
            <th className='license-details-cell'>{t('license.avalableUsage')}</th>
            <th className='license-details-cell'>{t('license.leftUsage')}</th>
          </tr>
        </thead>
        <tbody className='license-details-body'>
          <tr className={'license-details-row ' + getLowLeftClass(licenseUsage.maxOperators, licenseUsage.operatorsLeft)}>
            <td className='license-details-cell'>{t('license.operatorUsage')}</td>
            <td className='license-details-cell'>{licenseUsage.currentOperators}</td>
            <td className='license-details-cell'>{licenseUsage.maxOperators}</td>
            <td className='license-details-cell'>{licenseUsage.operatorsLeft}</td>
          </tr>
          <tr className={'license-details-row ' + getLowLeftClass(licenseUsage.maxBots, licenseUsage.botsLeft)}>
            <td className='license-details-cell'>{t('license.botUsage')}</td>
            <td className='license-details-cell'>{licenseUsage.currentBots}</td>
            <td className='license-details-cell'>{licenseUsage.maxBots}</td>
            <td className='license-details-cell'>{licenseUsage.botsLeft}</td>
          </tr>
          <tr className={'license-details-row ' + getLowLeftClass(licenseUsage.maxNlp, licenseUsage.nlpLeft)}>
            <td className='license-details-cell'>{t('license.nlpUsage')}</td>
            <td className='license-details-cell'>{licenseUsage.currentNlp}</td>
            <td className='license-details-cell'>{licenseUsage.maxNlp}</td>
            <td className='license-details-cell'>{licenseUsage.nlpLeft}</td>
          </tr>
          <tr className={'license-details-row ' + getLowLeftClass(licenseUsage.maxMailing, licenseUsage.mailingLeft)}>
            <td className='license-details-cell'>{t('license.mailingUsage')}</td>
            <td className='license-details-cell'>{licenseUsage.currentMailing}</td>
            <td className='license-details-cell'>{licenseUsage.maxMailing}</td>
            <td className='license-details-cell'>{licenseUsage.mailingLeft}</td>
          </tr>
        </tbody>
        
      </table>
    </div>
  )
}


